(() => {
  'use strict';
  if (window.__shopbroNativeCardLayout) return;
  window.__shopbroNativeCardLayout = true;
  let pending = false;
  function refresh() {
    pending = false;
    for (const wrapper of document.querySelectorAll('[data-shopbro-compact-card]')) {
      const info = wrapper.querySelector('.card > .card__content > .card__information');
      const heading = info?.querySelector('.card__heading');
      if (!info || !heading) continue;
      const top = `${heading.offsetTop + heading.offsetHeight + 4}px`;
      if (info.style.getPropertyValue('--shopbro-review-top') !== top) info.style.setProperty('--shopbro-review-top', top);
    }
  }
  function schedule() { if (!pending) { pending = true; requestAnimationFrame(refresh); } }
  function start() {
    const root = document.querySelector('#ProductGridContainer');
    if (!root) return;
    new MutationObserver(schedule).observe(root, {childList:true, subtree:true});
    if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(root);
    schedule();
  }
  window.addEventListener('resize', schedule, {passive:true});
  document.fonts?.ready.then(schedule);
  document.fonts?.addEventListener('loadingdone', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
})();
